import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/company',
        component: () => import('../views/CompanyView.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/CompanyCultureView.vue'),
                meta: { title: '企业文化' }
            }
        
        ]
    },
    {
        path: '/careers',
        redirect: '/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/product/productDetail/:id',
        name: 'ProductDetail',
        component:  () => import('../views/ProductDetailsView.vue')
    },
    {
        path: '/product',
        component: () => import('../views/ProductView.vue'),
        children: [
            {
                path: '',
                redirect: 'huangyuan'
            },
            {
                path: ':id', // 动态路由参数
                component: () => import('@/views/ProductListView.vue'),
                props: true, // 启用props接收路由参数
                meta: {
                    title: '产品详情',
                    // 为特定产品预设meta信息
                    productMeta: {
                        huangyuan: { title: '黄原胶' },
                        jieleng: { title: '结冷胶' },
                        kederan: { title: '可得然胶' },
                        wenlun: { title: '温轮胶(威兰胶)' },
                        sanzan: { title: '三赞胶' }
                    }
                }
            }
        ]
    },
    {
        path: '/support',
        component: () => import('../views/SupportView.vue'),
        children: [
            {
                path: '', // 空路径默认子路由
                redirect: 'download'
            },
            {
                path: 'download',
                component: () => import('@/views/DownLoadView.vue'),
                meta: { title: '资料下载' }
            },
            {
                path: 'question',
                component: () => import('@/views/DownLoadView.vue'),
                meta: { title: '问题指南' }
            },
        ]
    },
    {
        path: '/news',
        component: () => import('../views/NewsView.vue'),
        children: [
            {
                path: '', // 空路径默认子路由
                redirect: 'company'
            },
            {
                path: 'company',
                component: () => import('@/views/CompanyNewsView.vue'),
                meta: { title: '企业' }
            },
            {
                path: 'detail',
                component: () => import('@/views/NewsDetail.vue'),
                meta: { title: '企业' },
                props: (route) => ({
                    content: route.query.content ? decodeURIComponent(route.query.content) : ''
                })
            }
            // {
            //     path: 'industry',
            //     component: () => import('@/views/CompanyNewsView.vue'),
            //     meta: { title: '行业动态' }
            // },
        ]
    },
    {
        path: '/contact',
        component: () => import('../views/ContactUsView.vue'),
        children: [
            {
                path: '', // 空路径默认子路由
                redirect: 'our'
            },
            {
                path: 'our',
                component: () => import('@/views/ContactUsDetailView.vue'),
                meta: { title: '联系我们' }
            }
            // {
            //     path: 'cn',
            //     component: () => import('@/views/ContactUsDetailView.vue'),
            //     meta: { title: '境内成员' }
            // },
            // {
            //     path: 'abroad',
            //     component: () => import('@/views/ContactUsDetailView.vue'),
            //     meta: { title: '联系我们' }
            // }
        ]
    },
    {
        path: '/about',
        component: () => import('@/views/AboutView.vue'), // 添加父路由组件
        children: [
            {
                path: '', // 空路径默认子路由
                redirect: 'chairman'
            },
            {
                path: 'companyInfo',
                component: () => import('@/views/AboutCompanyView.vue'),
                meta: { title: '企业简介' }
            },
            // {
            //     path: 'ningdong',
            //     component: () => import('@/views/NingDongView.vue'),
            //     meta: { title: '宁东基地' }
            // },
            {
                path: 'chairman',
                component: () => import('@/views/ChairmanView.vue'),
                meta: { title: '董事长致辞' }
            },
            // {
            //     path: 'companyInfo2',
            //     component: () => import('@/views/AboutCompanyView.vue'),
            //     meta: { title: '资质荣誉' }
            // },
            {
                path: 'development',
                component: () => import('@/views/DevelopmentView.vue'),
                meta: { title: '发展战略' }
            }
        ]

    },
    {
        path: '/talent',
        component: () => import('@/views/TalentView.vue'), // 添加父路由组件
        children: [
            {
                path: '', // 空路径默认子路由
                redirect: 'reserve'
            },
            {
                path: 'reserve',
                component: () => import('@/views/TalentReserveView.vue'),
                meta: { title: '人才战略储备' }
            },
            {
                path: 'job',
                component: () => import('@/views/TalentJobView.vue'),
                meta: { title: '人才介绍' }
            }
        ]

    }
]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 如果返回了保存的位置（浏览器前进/后退），使用保存的位置
        if (savedPosition) {
            return savedPosition;
        }
        // 否则返回页面顶部
        return { x: 0, y: 0 };
    }
  });

export default router
